export default __webpack_public_path__ + "static/media/dooropen.bd390c21.mp3";